<template>
  <div class="box13" id="box13">
    <div class="title">
      课程满足多群体学习需求
      <br />职业发展路径明确
    </div>
    <img src="../../../assets/coursePage/pythonData/box13/road.png" alt="" />
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped>
.box13 {
  padding-top: 80px;
  position: relative;
  z-index: 5;
  width: 100%;
  height: 1076px;
  background: url("../../../assets/coursePage/pythonData/box13/bg.png")
    no-repeat;
  background-size: cover;
  box-sizing: border-box;
  text-align: center;
  font-size: 40px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ffffff;
  line-height: 56px;
  img {
    margin-top: 32px;
    width: 750px;
    height: 704px;
  }
}
</style>
